module.exports = __webpack_public_path__ + "img/热销商品3.43758785.png";